(function($) {

  $(function() {

    let linkSelector = Array.prototype.slice.call(document.querySelectorAll(".js-target-blank"));
    if (linkSelector.length > 0) {
      linkSelector.forEach(link => {
        link.setAttribute('target', '_blank');
      });
    }

  });

})(jQuery);